// extracted by mini-css-extract-plugin
module.exports = {"button":"BackButton_button__rUZkO","button__icon":"BackButton_button__icon__WoU5g"};